exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trans-nav-container[data-v-0bb4f5c4]{border-radius:1rem;transition:all .3s ease}@media (min-width:992px){.trans-nav-container[data-v-0bb4f5c4]{border-radius:50rem!important}}", ""]);

// exports
